import { get } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { getRole } from "helpers/permissions/roles"
import { Creators } from "./model"
import { Creators as HookCreators } from "model/hookUpdater"
import { Creators as DialogCreators } from "modules/dialog/model"
import { Creators as notificationCreators } from "modules/notifications/model"
import { getAllowedResources, getPermissions, getResourceLimits } from "./selectors"
import withUrlParams from "hocs/withUrlParams"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    applicationAlias: props.params.app,
  }),
  required: ["account", "applicationAlias"],
  data: [{
    resource: "resources",
    url: () => ({
      query: `{
          resources {
            id
            type
            alias
            name
            description
            updatedAt
            permissionLevel
          }
        }`,
    }),
  }, {
    resource: "application",
    url: ({ applicationAlias }) => ({
      id: `application-${applicationAlias}`,
      query: `query ($applicationAlias: IdOrAlias!) {
        application (id: $applicationAlias) {
          name
          id
          alias
          name
          description
        }
      }`,
      variables: {
        applicationAlias,
      },
    }),
  }, {
    resource: "applicationPermissions",
    url: ({ applicationAlias }) => ({
      id: `application-permissions-${applicationAlias}`,
      query: `query ($applicationAlias: IdOrAlias!) {
        application (id: $applicationAlias) {
          resourcePermissions {
            id
            type
            alias
            name
            description
            permissionLevel
            createdAt
            updatedAt
          }
        }
      }`,
      variables: {
        applicationAlias,
      },
    }),
  }, {
    resource: "accountPartner",
    url: ({ account, applicationAlias }) => `/api/${account}/accountPartners/${applicationAlias}`,
  }],
  mapStateToProps: (state, props) => ({
    role: getRole(state),
    application: get(props, "application.application"),
    resources: getAllowedResources(state),
    permissions: getPermissions(state),
    resourceLimits: getResourceLimits(state),
  }),
  actions: {
    ...Creators,
    ...HookCreators,
    addNotification: notificationCreators.add,
    openDialog: DialogCreators.open,
  },
}))
